export default "__VITE_ASSET__7hhQUQmB__"